import {Typography} from '@mui/material';
import React, {useEffect} from 'react';
import {styled} from '@mui/material/styles';
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import Slider from "@mui/material/Slider";
import Input from "@mui/material/Input";
import red from "@mui/material/colors/red";
import green from "@mui/material/colors/green";
import {grey} from "@mui/material/colors";
import PropTypes from 'prop-types';
import {variants} from "./ColorSliders";


const StyledColorLabel = styled(Typography)(({theme, type}) => ({
    textAlign: 'center',
    userSelect: 'none',
    display: 'inline-block',
    color: grey[500],
    ...(type === variants.RED && {color: 'red' }),
    ...(type === variants.GREEN && {color: 'green' }),
    ...(type === variants.BLUE && {color: 'blue' }),
}));


export default function ColorSlider(props) {

    const { type, value, onChange, disabled } = props;

    const [label, setLabel] = React.useState('');

    useEffect(() => {
        switch(type) {
            case variants.RED:
                setLabel('R');
                break;
            case variants.GREEN:
                setLabel('G');
                break;
            case variants.BLUE:
                setLabel('B');
                break;
            case variants.ALPHA:
                setLabel('A');
                break;
            default:
                setLabel('RGB');
                break;
        }
    }, [type]);

    const handleChange = (event, newValue) => {
        if (event.target.type === 'number')
            onChange(type, event.target.value === '' ? '' : Number(event.target.value));
        else
            onChange(type, newValue);
    };

    const capitalize = s => {
        if (typeof s !== 'string')
            return '';
        return s.charAt(0).toUpperCase() + s.slice(1)
    };

    return (
        <Grid item container spacing={0} xs={12}>
            <Grid item xs={3} sx={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <Tooltip title={`${capitalize(type)} threshold`}>
                    <StyledColorLabel variant={'h5'} type={type} >{label}</StyledColorLabel>
                </Tooltip>
            </Grid>
            <Grid item xs={7} sx={{pr: 1}} container alignItems='center'>
                <Slider
                    defaultValue={0} step={1} min={0} max={255} value={value}
                    valueLabelDisplay={'auto'}
                    onChange={handleChange}
                    disabled={disabled}
                />
            </Grid>
            <Grid item xs={2}>
                <Input margin={'dense'}
                       value={value}
                       onChange={handleChange}
                       disabled={disabled}
                       inputProps={{
                           step: 1,
                           min: 0,
                           max: 255,
                           type: 'number',
                       }}
                />
            </Grid>
        </Grid>
    );
}

ColorSlider.defaultProps = {
    variant: 'alpha',
    value: 0,
    setValue: undefined,
    disabled: false,
};

ColorSlider.propTypes = {
    onChange: PropTypes.func.isRequired,
}
